import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {GroupConfig} from '../../../shared/models/config';
import {select, Store} from '@ngrx/store';
import * as fromSites from '../../reducers';
import {Observable, Subscription} from 'rxjs';
import {Player} from '../../../shared/models/player';
import {SelectedPlayers} from '../../models/player-filter';
import {RemoveMultiSubPlayerAction, RemovePlayerAction} from '../../actions/remove-player';
import {GetConfigSiteService} from '../../services/get-config-site.service';
import { GetFormsServiceLocal} from '../../services/get-form-service';
import {DefaultPlayerAction} from '../../actions/default-player';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {Router} from '@angular/router';

@Component({
  selector: 'storever-remove-player',
  templateUrl: './remove-player.component.html',
  styleUrls: ['./remove-player.component.scss']
})
export class RemovePlayerComponent implements OnInit , OnDestroy {


  form: FormGroup;
  formSoldOrLost: FormGroup;
  formConfig: GroupConfig;
  formConfigSoldOrLost: GroupConfig;
  players$: Observable<Player[]>;
  selectedPlayers$: Observable<SelectedPlayers[]>;
  selectedPlayer: SelectedPlayers;
  players: Player[];
  private sub$: Subscription;
  showhideReason: boolean;
  @ViewChild('elementGroup', {static: false}) el: ElementRef;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              viewContainerRef: ViewContainerRef,
              private getFormsService: GetFormsServiceLocal,
              private bsModalRef: BsModalRef,
              private router: Router,
              private storeSite: Store<fromSites.AppState>,
              private getConfigSite: GetConfigSiteService) {
  }

  ngOnInit(): void {
    this.form = this.getFormsService.getRemovePlayer();
    this.formConfig = this.getConfigSite.getConfigRemovePlayer();

    this.formSoldOrLost = this.getFormsService.getRemovePlayerLostOrSold()
    this.formConfigSoldOrLost = this.getConfigSite.getConfigRemovePlayerLostOrSold();

    this.players$ = this.storeSite.pipe(select(fromSites.selectors.getPlayers));
    this.selectedPlayers$ = this.storeSite.pipe(select(fromSites.selectors.getPlayersSelected));
    this.sub$ = this.selectedPlayers$.subscribe(( selectedPlayer => {
      if (selectedPlayer && selectedPlayer[0]) {
        this.selectedPlayer = selectedPlayer[0];
      }
    })
    );
    this.players$.subscribe(( players => {
        this.players = players;
        if (players) {
          if (players.length === 2) { // we need to select one player by default if there are 2 players list
            for (let i = 0; i < players.length   ; i++) {
              if (this.selectedPlayer.deviceID !== players[i].deviceID) {
                this.patchValue(players[i].deviceID,   this.formSoldOrLost.get('reason').value);
              }
            }
        }
        }
      })
    );
  }

  patchValue(deviceID: string , reason: string): void {
    if (this.showhideReason) {
      this.form.patchValue({
        playerList: {
          reason: reason,
        },
      });
    }
    this.form.patchValue({
      playerList: {
        deviceID: deviceID,
      },
    });
  }

  sendWithForm(): void {
    // console.log(this.form.get(['playerList' , 'deviceID']).value)
    this.storeSite.dispatch(new DefaultPlayerAction(this.form.get(['playerList' , 'deviceID']).value));
    this.close();
  }

  send(): void {
    if (this.router.url.split('?')[0].search('multi') === -1 || !this.selectedPlayer.subscriptionUuid) {
      this.storeSite.dispatch(new RemovePlayerAction({
        'deviceID': this.selectedPlayer.deviceID,
        'reason': this.formSoldOrLost.get('reason').value
      }));
    } else {
      this.storeSite.dispatch(new RemoveMultiSubPlayerAction({
        'deviceID': this.selectedPlayer.deviceID,
        'subscriptionUuid': this.selectedPlayer.subscriptionUuid,
        'reason': this.formSoldOrLost.get('reason').value
      }));
    }
    this.close();
  }

  close(): void {
    this.bsModalRef.hide()
  }
  displayPlayerList(): boolean {
    if (this.router.url.split('?')[0].search('multi') !== -1) {
      return false;
    }
    return this.selectedPlayer.isDefault && this.players.length > 1;
  }

  ngOnDestroy(): void {
    if (this.sub$) {
      this.sub$.unsubscribe();
    }
  }

}
